import {ILiveEventRecording} from '@services/live-events/live-events.model';

export const findRecordingById = (
    recordings: ILiveEventRecording[],
    id: number | undefined,
) => {
    if (!id) {
        return null;
    }
    const idx = recordings.findIndex(recording => recording.id === id);

    if (idx !== -1) {
        return {recording: recordings[idx], recordingIndex: idx};
    }

    return null;
};
